import { Button, Card, Form } from "react-bootstrap";
import { ConfirmarEmailCode } from "./ConfirmarEmail.Code";
import styles from "./styles.module.css";
import { ButtonSpinner } from "../../../componentes";

const ConfirmarEmailView = () => {
  const code = ConfirmarEmailCode();

  return (
    <div
      className={`d-flex justify-content-center align-items-center ${styles.painel}`}
    >
      <Card className="col-11 col-sm-6 col-md-5 col-lg-4 col-3">
        <Card.Header>Confirmar E-mail</Card.Header>
        <Card.Body>
          <Form noValidate onSubmit={code.onSubmit}>
            <div className="mb-4 text-center">
              <p className="text-muted mb-1">
                Enviamos um código de confirmação para o e-mail:
              </p>
              <strong className="d-block text-break">{code.email}</strong>
            </div>

            <div className="mb-4 text-center">
              <Form.Label className="text-muted">
                Código de 6 dígitos
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="------"
                maxLength={6}
                value={code.codigo}
                onChange={(e) =>
                  code.setCodigo(e.target.value.replace(/\D/g, ""))
                }
                style={{
                  textAlign: "center",
                  fontSize: "28px",
                  letterSpacing: "10px",
                  fontWeight: "bold",
                  fontFamily: "monospace",
                  paddingLeft: "15px",
                }}
              />
            </div>

            <div className="mb-4 text-center">
              {code.timeLeft > 0 ? (
                <div className="text-warning mb-2">
                  O código expira em: <strong>{code.formatTime(code.timeLeft)}</strong>
                </div>
              ) : (
                <div className="text-danger mb-2">O código expirou!</div>
              )}

              <Button
                variant="outline-primary"
                size="sm"
                onClick={code.handleResend}
                disabled={code.resending}
              >
                {code.resending ? "Enviando..." : "Reenviar novo código"}
              </Button>
            </div>

            <div className="d-grid gap-2">
              <ButtonSpinner
                variant="primary"
                type="submit"
                loading={code.submitting}
                disabled={code.timeLeft === 0}
              >
                Confirmar Conta
              </ButtonSpinner>
            </div>

            <div className="d-flex justify-content-between mt-3">
              <Button
                variant="link"
                onClick={code.onClickNavigate("/login")}
                className="ps-0"
              >
                Voltar para o Login
              </Button>
              <Button
                variant="link"
                onClick={code.onClickNavigate("/cadastro")}
                className="pe-0"
              >
                Criar Nova Conta
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ConfirmarEmailView;
